import { useEffect, useState } from "react"
import ordini_fetch from "../fetch/ordini_fetch"
import { format } from "date-fns"


export default function View({ordineId}) {
    const [ordine , setOrdine] = useState({})

    useEffect(() => {
        readOdine()
    }, [ordineId])

    const readOdine = async () => {
        const {data} = await ordini_fetch.get({id : ordineId})
        setOrdine(data)
    }

   //console.log(ordine , ' ordine');
    
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 d-flex flex-wrap">

                    <p className='col-4' >
                        <span className="fw-bold">Richiesto da  : </span> {ordine?.utente?.username} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Codice articolo  : </span> {ordine?.prodotto?.rifInterno} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Articolo  : </span> {ordine?.prodotto?.descrizione} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Qantità  : </span> {ordine?.qt} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Fornitore  : </span> {ordine?.fornitore?.viewName || 'Non assegnato'} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Data richiesta  : </span> {ordine.dataCreate && format(ordine.dataCreate, "dd-MM-yyyy HH:mm")} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Data per cui è richiesto il articolo  : </span> {ordine?.dataRichiestaPer ? format(ordine?.dataRichiestaPer, "dd-MM-yyyy ") : ''} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Data ordine  : </span> {ordine?.dataOrdine && format(ordine?.dataOrdine, "dd-MM-yyyy ")} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Data arrivo previsto  : </span> {ordine?.dataArrivoPrev && format(ordine?.dataArrivoPrev, "dd-MM-yyyy ")} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Ordinato Da  : </span> {ordine?.dataArrivoPrev && format(ordine?.dataArrivoPrev, "dd-MM-yyyy ")} <br />
                    </p>
                    <p className='col-4' >
                        <span className="fw-bold">Note : </span> {ordine?.note} <br />
                    </p>
                    
                </div>
            </div>
        </div>
    )
}